import React from 'react';
import type { TakenSeat } from 'lib/LobbyEntities';
import { TILE_TYPE, NUMBER_LIST_TYPE, type NumberListType } from '../../constants';
import NumberList from '../NumberList/NumberList';
import './embeddedTileInfo.css';

interface TileInfo {
  tileType?: (typeof TILE_TYPE)[keyof typeof TILE_TYPE];
  results?:
    | (string | number)[]
    | {
        value: number | string;
        multiplier?: number;
      }[]
    | null
    | undefined;
  takenSeats?: TakenSeat[];
}

interface EmbeddedTileInfoProps {
  tileInfo?: TileInfo;
}

const EmbeddedTileInfo: React.FC<EmbeddedTileInfoProps> = ({ tileInfo }) => {
  if (!tileInfo || typeof tileInfo !== 'object' || !tileInfo.tileType) return null;

  const { tileType } = tileInfo;

  let embeddedInfo: JSX.Element | null = null;

  const renderNumberList = (
    numbers: (
      | string
      | number
      | { value?: string | number; multiplier?: number; seat?: number; isTaken?: boolean }
    )[],
    type: NumberListType
  ) => <NumberList numbers={numbers as number[]} type={type} maxLength={7} />;

  switch (tileType) {
    case TILE_TYPE.ROULETTE:
    case TILE_TYPE.ROULETTE_MULTIPLIER:
      embeddedInfo = renderNumberList(tileInfo.results || [], NUMBER_LIST_TYPE.ROULETTE);
      break;
    case TILE_TYPE.BLACKJACK:
      embeddedInfo = renderNumberList(tileInfo.takenSeats || [], NUMBER_LIST_TYPE.BLACKJACK);
      break;
    case TILE_TYPE.MONEYWHEEL:
      embeddedInfo = renderNumberList(tileInfo.results || [], NUMBER_LIST_TYPE.UNIFORM_SQUARES);
      break;
    default:
      break;
  }

  return <div className="embeddedTileInfo">{embeddedInfo}</div>;
};

export default EmbeddedTileInfo;
